import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CyclingLoadingMessagesComponent } from '../../cycling-loading-messages/cycling-loading-messages.component';
import { SettingsService } from '../../services/settings-service/settings.service';

@Component({
	selector: 'app-login-form',
	standalone: true,
	imports: [CommonModule, FormsModule, CyclingLoadingMessagesComponent],
	templateUrl: './login-form.component.html',
	styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {
	// Input properties for customization
	@Input() buttonText = 'Kirjaudu sisään';
	@Input() showLogo = false;
	@Input() isLoggingIn = false;
	@Input() loginError = '';

	// Form fields
	username = '';
	password = '';

	// Output events
	@Output() loginAttempt = new EventEmitter<{
		username: string;
		password: string;
	}>();
	@Output() formStateChange = new EventEmitter<{ valid: boolean }>();

	settingsService = inject(SettingsService);

	onLogin() {
		if (!this.username || !this.password) {
			return;
		}

		this.loginAttempt.emit({
			username: this.username,
			password: this.password,
		});
	}

	onFormChange() {
		const isValid = !!(this.username && this.password);
		this.formStateChange.emit({ valid: isValid });
	}
}
